function updateTotalPrice() {
  // Get the base price from .price-item--regular (Detect currency from the text)
  let basePriceText = $(".price-item--regular").text().trim();
  let basePrice = parseFloat(basePriceText.replace(/[^0-9.]/g, "")) || 0;
  let currency = basePriceText.includes("USD") ? "USD" : "CAD"; // Detect currency

  // Get the selected quantity
  let quantity = parseInt($("#qty-total").val()) || 1;

  // Calculate the total price
  let totalPrice = basePrice * quantity;

  // Update the total price in .total_amount with the detected currency
  $(".total_amount").text(`$${totalPrice.toFixed(2)} ${currency}`);
}

$(document).ready(function () {
  // Select all slides (both main and thumbnails)
  let slides = $(".desktop_gallery .product__media-item.slider__slide");
  let totalSlides = slides.length; // Correct total slide count

  // Hide navigation buttons if there are no images or only one image
  if (totalSlides <= 1) {
    $(".gallery-btn-left, .gallery-btn-right").hide();
  }

  console.log("Total Slides:", totalSlides);

  /* desktop gallery control */

  $(".desktop_gallery .gallery-btn-right").click(function () {
    // Select all slides (both main and thumbnails)
    let slides = $(".desktop_gallery .product__media-item.slider__slide");
    let totalSlides = slides.length; // Correct total slide count

    console.log("desktop_mobile ... loading :" + totalSlides);

    // Find the active slide
    let activeSlide = slides.filter(".is-active");

    // Get the current position (zero-based index)
    let position = slides.index(activeSlide);
    let next = position + 1;

    console.log(next + " :" + totalSlides);
    // If we exceed the last slide, loop back to the first one (zero-based index)
    if (next >= totalSlides) {
      next = 0;
    }

    // Find the corresponding thumbnail and trigger click
    let nextThumbnail = $(".desktop_gallery .thumbnail-list__item")
      .eq(next)
      .find("button");

    if (nextThumbnail.length) {
      nextThumbnail.trigger("click");
    } else {
      console.warn("Thumbnail not found for position:", next);
    }
  });

  $(".desktop_gallery .gallery-btn-left").click(function () {
    // Select all slides (both main and thumbnails)
    let slides = $(".desktop_gallery .product__media-item.slider__slide");
    let totalSlides = slides.length; // Correct total slide count

    // Find the active slide
    let activeSlide = slides.filter(".is-active");

    // Get the current position (zero-based index)
    let position = slides.index(activeSlide);
    let prev = position - 1;

    // If we go before the first slide, loop back to the last one
    if (prev < 0) {
      prev = totalSlides - 1;
    }

    // Find the corresponding thumbnail and trigger click
    let prevThumbnail = $(" .desktop_gallery .thumbnail-list__item")
      .eq(prev)
      .find("button");

    if (prevThumbnail.length) {
      prevThumbnail.trigger("click");
    } else {
      console.warn("Thumbnail not found for position:", prev);
    }
  });
});

//mobile gallery contorl

$(document).ready(function () {
  // Select all slides (both main and thumbnails)
  let slides = $(".desktop_mobile .product__media-item.slider__slide");
  let totalSlides = slides.length; // Correct total slide count

  console.log("desktop_mobile ... loading :" + totalSlides);

  // Hide navigation buttons if there are no images or only one image
  if (totalSlides <= 1) {
    $(".gallery-btn-left, .gallery-btn-right").hide();
  }

  console.log("Total Slides:", totalSlides);

  $(".desktop_mobile .gallery-btn-right").click(function () {
    // Select all slides (both main and thumbnails)
    let slides = $(".desktop_mobile .product__media-item.slider__slide");
    let totalSlides = slides.length; // Correct total slide count

    // Find the active slide
    let activeSlide = slides.filter(".is-active");

    // Get the current position (zero-based index)
    let position = slides.index(activeSlide);
    let next = position + 1;

    console.log(next + " :" + totalSlides);
    // If we exceed the last slide, loop back to the first one (zero-based index)
    if (next >= totalSlides) {
      next = 0;
    }

    // Find the corresponding thumbnail and trigger click
    let nextThumbnail = $(".desktop_mobile .thumbnail-list__item")
      .eq(next)
      .find("button");

    if (nextThumbnail.length) {
      nextThumbnail.trigger("click");
    } else {
      console.warn("Thumbnail not found for position:", next);
    }
  });

  $(".desktop_mobile .gallery-btn-left").click(function () {
    // Select all slides (both main and thumbnails)
    let slides = $(".desktop_mobile .product__media-item.slider__slide");
    let totalSlides = slides.length / 2; // Correct total slide count

    // Find the active slide
    let activeSlide = slides.filter(".is-active");

    // Get the current position (zero-based index)
    let position = slides.index(activeSlide);
    let prev = position - 1;

    // If we go before the first slide, loop back to the last one
    if (prev < 0) {
      prev = totalSlides - 1;
    }

    // Find the corresponding thumbnail and trigger click
    let prevThumbnail = $(" .desktop_mobile .thumbnail-list__item")
      .eq(prev)
      .find("button");

    if (prevThumbnail.length) {
      prevThumbnail.trigger("click");
    } else {
      console.warn("Thumbnail not found for position:", prev);
    }
  });
});

$(document).ready(function () {
  var $quantityInput = $("#qty-total"); // The visible quantity field
  var $hiddenForm = $(".product-form form"); // Hidden SC Products form
  var $addToCartBtn = $(".product-form__submit"); // The real Add to Cart button

  if (!$quantityInput.length || !$hiddenForm.length || !$addToCartBtn.length) {
    console.error("One or more required elements not found.");
    return;
  }

  // Before form submission, update hidden form with the correct quantity
  $addToCartBtn.on("click", function (e) {
    var quantityValue = $quantityInput.val();

    // Find or create the hidden quantity input inside Shopify form
    var $hiddenQuantityInput = $hiddenForm.find("input[name='quantity']");
    if (!$hiddenQuantityInput.length) {
      $hiddenQuantityInput = $("<input>", {
        type: "hidden",
        name: "quantity",
      }).appendTo($hiddenForm);
    }

    // Update the hidden quantity input value
    $hiddenQuantityInput.val(quantityValue);

    console.log("Submitting with quantity:", $hiddenQuantityInput.val()); // Debugging
  });

  updateTotalPrice();

  $("#qty-total").on("input", function () {
    updateTotalPrice();
  });

  var updateTimeout;
  jQuery("form.form").on(
    "change input",
    "input, select, textarea",
    function () {
      // Get the updated form value
      console.log("form update price");
      updateTotalPrice();

      clearTimeout(updateTimeout); // Clear previous timeout if still running

      updateTimeout = setTimeout(function () {
        console.log("form update price");
        updateTotalPrice();
      }, 1000); // Delay execution by 1 second
    }
  );

  $("button.minus_qty").on("click", function () {
    console.log("Minus");
    let qtyInput = $("#qty-total");
    let currentValue = parseInt(qtyInput.attr("value")) || 1;

    // Decrease the value, but not below the min value
    if (currentValue > 1) {
      currentValue--; // Increment the value once
      qtyInput.val(currentValue);
      qtyInput.attr("value", currentValue);
      console.log("update price");
      updateTotalPrice();
    }
  });

  $("button.plus_qty").on("click", function () {
    let qtyInput = $("#qty-total");
    let currentValue = parseInt(qtyInput.attr("value")) || 1;
    currentValue++; // Increment the value once
    qtyInput.val(currentValue);
    qtyInput.attr("value", currentValue);
    console.log("update price");
    updateTotalPrice();
  });
});
